import React, { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { AuthContext } from "../../context/Auth/AuthContext";
import { useAdminStyles } from "./styles";

// Moldura do backoffice: título + abas. Fica separado das telas para que
// acrescentar uma aba não mexa em nenhuma delas.
//
// `dinheiro: true` = só a governança vê. O servidor recusa essas rotas para o
// suporte de qualquer forma (middleware isGovernance); esconder aqui evita
// oferecer uma porta que vai bater na cara de quem clicar.
const TABS = [
  { path: "/admin", label: "Visão geral" },
  { path: "/admin/users", label: "Usuários" },
  { path: "/admin/revenue", label: "Receita", dinheiro: true },
  { path: "/admin/plans", label: "Planos", dinheiro: true },
  { path: "/admin/aws-costs", label: "Custos AWS", dinheiro: true },
  { path: "/admin/operations", label: "Operação" },
  { path: "/admin/telephony", label: "Telefonia" },
];

const Shell = ({ title, children, right }) => {
  const classes = useAdminStyles();
  const history = useHistory();
  const { pathname } = useLocation();
  const { user } = useContext(AuthContext);
  const podeVerDinheiro = !!(user && user.canSeeMoney);

  return (
    <div className={classes.page}>
      <div className={classes.wrap}>
        <div className={classes.head}>
          <div className={classes.h1}>{title || "Backoffice"}</div>
          <div className={classes.grow} />
          {right}
        </div>
        <div className={classes.tabs}>
          {TABS.filter(t => !t.dinheiro || podeVerDinheiro).map(t => {
            const on = t.path === "/admin" ? pathname === "/admin" : pathname.startsWith(t.path);
            return (
              <div
                key={t.path}
                className={`${classes.tab} ${on ? classes.tabOn : ""}`}
                onClick={() => history.push(t.path)}
              >
                {t.label}
              </div>
            );
          })}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Shell;
